import Input from '../../fields/input/input.component';
import OdinIcon, { OdinIconSize } from '../../odin-icon/odin-icon.component';

export interface TextSearchFieldProps {
  id: string;
  currentValue: string;
  onInputChanged: (searchText?: string) => void;
}

export default function TextSearchField({ currentValue, onInputChanged, id }: TextSearchFieldProps) {
  return (
    <div className="odin-flex odin-bg-mono-1 odin-border odin-border-gray-4 odin-h-full">
      <Input
        name="text-search-filter"
        id={id}
        type="text"
        value={currentValue}
        onChange={onInputChanged}
        inputStyles="focus:odin-outline-none odin-leading-6 !odin-border-none"
        trimWhitespace={false}
      />
      <div className="odin-flex odin-shrink odin-items-center odin-pr-1 odin-cursor-pointer">
        <OdinIcon size={OdinIconSize.ExtraSmall} icon="Search" />
      </div>
    </div>
  );
}
